var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0A11.5,11.5,0,1,0,23,11.5,11.51,11.51,0,0,0,11.5,0Zm0,22A10.5,10.5,0,1,1,22,11.5,10.51,10.51,0,0,1,11.5,22ZM15,9a3.5,3.5,0,0,1-3,3.46V15a.5.5,0,0,1-1,0V12a.5.5,0,0,1,.5-.5A2.5,2.5,0,1,0,9,9,.5.5,0,0,1,8,9a3.5,3.5,0,0,1,7,0Zm-3.5,7.5a1,1,0,1,0,1,1A1,1,0,0,0,11.5,16.5Zm0,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.c53374e1ed7fd33e09b29332c412474d.svg";
export { ForwardRef as ReactComponent };